import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { usePageSeo } from "../lib/seo";

export default function Terms() {
  usePageSeo({
    title: "Terms of Service | Equitas Homes",
    description: "Terms of Service for the Equitas Homes home-valuation tool, including limitation of liability for automated (AVM) valuations.",
    canonical: "https://equitashomes.com/terms",
  });
  return (
    <div className="min-h-screen bg-brand-cream paper-grain flex flex-col" data-testid="terms-page">
      <Header />
      <main className="flex-1 mx-auto max-w-3xl px-5 sm:px-8 py-16">
        <span className="eyebrow">Legal</span>
        <h1 className="mt-3 font-serif text-4xl text-brand-ink">Terms of Service</h1>
        <p className="mt-3 text-xs text-brand-stone/70">Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>
        <div className="mt-8 space-y-6 text-sm text-brand-stone leading-relaxed">
          <Section title="Acceptance of these terms">
            By accessing or using the Equitas Home Value tool (value.equitashomes.com), operated by Equitas Homes
            (Louis Fong, Broker, CA DRE #01151598), you agree to these Terms of Service. If you do not agree, please
            do not use the site.
          </Section>
          <Section title="Informational use only — not an appraisal">
            All home value figures, comparable sales, market statistics, and seller net-sheet amounts on this site are
            generated by automated valuation models (AVMs) and related algorithms for general informational purposes
            only. They are estimates, not appraisals, broker price opinions, or offers to buy or sell, and they are not
            a guarantee of any present or future sale price. A licensed appraisal or a broker-reviewed comparative
            market analysis is required for any reliance on a specific value.
          </Section>
          <Section title="No warranty on algorithmic valuations">
            Automated estimates depend on third-party and public data that may be incomplete, delayed, or inaccurate,
            and on modeling assumptions that may not reflect your property's actual condition, improvements, or local
            market dynamics. The site and all AVM outputs are provided "as is" and "as available," without warranties
            of any kind, express or implied, including accuracy, completeness, merchantability, or fitness for a
            particular purpose.
          </Section>
          <Section title="Limitation of liability">
            To the fullest extent permitted by law, Equitas Homes, Louis Fong, and their affiliates, data providers,
            and licensors are not liable for any direct, indirect, incidental, consequential, special, or punitive
            damages — including lost profits, lost equity, or decisions made in reliance on any automated valuation,
            comparable, or net-sheet figure — arising from your use of or inability to use this site. Your sole remedy
            for dissatisfaction with the site is to stop using it.
          </Section>
          <Section title="Commissions and fees">
            All brokerage commissions and fees are fully negotiable and are not set by law. Any comparison figures
            (for example, a 3% listing-fee illustration) are illustrative assumptions only. Buyer representation and
            dual agency are subject to applicable agreements and written-disclosure requirements.
          </Section>
          <Section title="Third-party data and trademarks">
            Market data is provided in part via Bridge Interactive. Zestimate® is a registered trademark of Zillow,
            Inc.; use of Zillow data is subject to Zillow's Terms of Use. Other names and marks are the property of
            their respective owners.
          </Section>
          <Section title="Fair housing">
            Equitas Homes is an Equal Housing Opportunity brokerage and complies with all federal and California fair
            housing laws.
          </Section>
          <Section title="Changes to these terms">
            We may update these Terms from time to time. Continued use of the site after changes are posted constitutes
            acceptance of the revised Terms.
          </Section>
          <Section title="Governing law">
            These Terms are governed by the laws of the State of California, without regard to its conflict-of-laws
            rules, and any dispute shall be resolved in the state or federal courts located in Santa Clara County,
            California.
          </Section>
          <Section title="Contact">
            Louis Fong, Broker, Equitas Homes · CA DRE #01151598 · (408) 561-1321 · louis@equitashomes.com
          </Section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
const Section = ({ title, children }) => (
  <div><h2 className="font-serif text-xl text-brand-ink">{title}</h2><p className="mt-2">{children}</p></div>
);
